export const EXPERIMENT_KEY = 'growth_callie_intro_entry_points'
export const CONTROL_VARIANT = 'control'
export const OPT_IN_VARIANT = 'post_intro_opt_in'
export const DEFAULT_ON_VARIANT = 'post_intro_default_on'
export const MULTI_SELECT_VARIANT = 'post_intro_multi_select'
export const TREATMENT_VARIANTS = [OPT_IN_VARIANT, DEFAULT_ON_VARIANT, MULTI_SELECT_VARIANT] as const
export const EXPERIMENT_VARIANTS = [CONTROL_VARIANT, ...TREATMENT_VARIANTS] as const

export type TreatmentVariant = typeof TREATMENT_VARIANTS[number]
export type ExperimentVariant = typeof EXPERIMENT_VARIANTS[number]
export type CallieResponse = 'opted_in' | 'opted_out'
export type PersistedCallieResponse = CallieResponse | 'deferred'
export type CallieChoice = 'ai' | 'link'
export type CompletionState = 'confirmation' | 'closed' | null

export type ResponsePayload = {
  response: CallieResponse
  schedulingLinkSelected?: boolean
}

export type ExperimentState = {
  variant?: string
  statsig_rule_id?: string
  post_intro_exposed_at?: string
  post_intro_response?: PersistedCallieResponse
  post_intro_callie_setup_status?: 'pending' | 'enabled' | 'failed'
}

export type CurrentUser = {
  email?: string
  growth_experiments?: Record<string, ExperimentState>
}

export type ExperienceProps = {
  isLoading: boolean
  onSave: (payload: ResponsePayload, enablesCallie: boolean) => void
}

export const isTreatmentVariant = (variant?: string): variant is TreatmentVariant => (
  TREATMENT_VARIANTS.some((treatmentVariant) => treatmentVariant === variant)
)

export const isExperimentVariant = (variant?: string): variant is ExperimentVariant => (
  EXPERIMENT_VARIANTS.some((experimentVariant) => experimentVariant === variant)
)
